<template>
  <div class="view-form fh">
    <div class="fh center" v-if="loadViewForm">
      <loading-circle />
    </div>
    <div v-else class="fh">
      <div class="view-form--nav module-header v-center space-between">
        <div class="flex gap-1">
          <img
            src="~@/assets/images/icons/arrow-back.svg"
            width="20"
            class="go-back"
            @click="goBack"
          />
          <div>
            <h2 class="module-name v-center">
              {{ formTemplateData?.name }} <div class="form-type"> <span class="header-default-dot">.</span> {{ formTemplateData?.core_form_type?.name }}</div>
            </h2>
            <div v-if="templateField" class="form-header-default">
              <span class="header-default-label">Created <span class="header-default-value">{{ getValuesFromForm('created_by') }}</span></span>
              <span class="header-default-label"> <span class="header-default-dot">.</span><span class="header-default-value">{{ getValuesFromForm('created_on') }}</span></span> &ensp;
              <span class="header-default-label" v-if="getValuesFromForm('updated_by')"> Updated <span class="header-default-value">{{ getValuesFromForm('updated_by') }}</span></span>
              <span class="header-default-label" v-if="getValuesFromForm('updated_by')"> <span class="header-default-dot">.</span><span class="header-default-value">{{ getValuesFromForm('updated_on') }}</span></span>
            </div>
          </div>
        </div>
        <div class="v-center flex-end py-3">
          <button class="btn mx-2" v-if="showReOpen" @click="reopenForm()">
            <img
              width="15px"
              src="~@/assets/images/icons/undo-icon.svg"
              v-tooltip="'Reopen Form'"
            />
          </button>
          <button
            class="btn btn-black v-center mx-2"
            @click="redirectToEditForm"
            v-if="editPermission"
            v-tooltip="'Edit Form'"
          >
            <img class="mr-1" src="~@/assets/images/pencil.svg" width="15" />
            Edit
          </button>
        </div>
      </div>
      <div class="view-form--maincontainer">
        <div class="view-form--container">
          <div class="fh center" v-if="loading">
            <loading-circle />
          </div>
          <div v-else class="view-form--elements">
            <div class="form-autogenerated" >
              <div  class="span-div" v-if="formData.sequence_value">
                <span class="label">Sequence ID </span>
                <span class="value">
                  {{ formData.sequence_value }}
                </span>
              </div>
              <template v-for="(ele, index) in templateField">
                <div
                  class="span-div"
                  :key="index"
                  v-if="ele.autogenerated && (ele.field_name !== 'project' || formData.project_id) && getkeysFromForm(ele.field_name)"
                >
                  <span class="label">{{ getkeysFromForm(ele.field_name) }} </span>
                  <div class="value">{{
                    getValuesFromForm(ele.field_name)
                  }}</div>
                </div>
              </template>
            </div>
              <div class="auto-gen-separator"></div>
            <div class="form-grid">
              <div class="form-grid__item" :class="getComponentGridClass('DATE')">
                <div
                  :class="{
                    'form-input': true,
                    'form-input--required': true,
                    'form-input--explicit-asterisk': true
                  }"
                >
                  <label class="form-input__label">
                    <span class="form-input__caption">Due Date<span class="form-input__asterisk">*</span></span>
                  </label>
                  <input v-model="formattedDueDate" :disabled="true" />
                </div>
              </div>
              <template v-for="(ele, index) in templateField">
                <div
                  v-if="
                    !ele.autogenerated &&
                    (ele.form_field.key !== 'BOM' || isOnProjectLevel)
                  "
                  :key="index"
                  :class="['form-grid__item', getComponentGridClass(ele.form_field.key)]"
                >
                  <component
                    :ref="ele.field_id"
                    :fieldId="ele.field_id"
                    :is="ele.form_field.key + '_COMPONENT'"
                    :data="ele"
                    :upload="ele?.form_field?.key === 'DOCUMENTS' ? true : false"
                    :value="formValueData[ele.field_id]"
                    :viewOnly="true"
                    mode="VIEW"
                    :formTypeId="formData?.form_type_id"
                    :formTemplate="true"
                    :formData="formData"
                    :factoryId="formData?.core_factory?.id"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="view-form--sideBar">
          <div class="tab-headers">
            <div
              v-for="(tab, index) in visibleTabs"
              :key="index"
              :class="['tab-header', { active: selectedTab === tab.id }]"
              class="v-center"
              @click="selectTab(tab.id)"
            >
              {{ tab?.name }}
            </div>
          </div>
          <div
            v-if="
              selectedTab === config.FORM_TAB_STATUS.REVISION_HISTORY ||
              selectedTab === config.FORM_TAB_STATUS.HISTORY
            "
            class="tab-body-parent"
          >
            <version-history
              :formTypeId="formData.form_type_id"
              :rootFormId="formData.root_parent_id"
              @selectedVersion="setup"
              :instanceId="wftInstaceId"
              :formId="formData.id"
              :selectedTab="selectedTab"
            />
          </div>
          <div v-if="selectedTab === config.FORM_TAB_STATUS.COMMENTS">
            <form-comment-panel
              :form="formData"
              :disabled="true"
              @closeComment="openComment = false"
              :closeOnOutsideClick="true"
            />
          </div>
          <div class="fh center" v-if="sideBarLoading">
            <loading-circle />
          </div>
          <div
            v-else-if="
              formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF &&
              selectedTab === config.FORM_TAB_STATUS.WORKFLOW &&
              !wftInstaceId
            "
          >
            <process-plan-list
              :mode="'view'"
              :material-process-plan-links="materialLinks"
              :material-names="materialNames"
              :material-id-to-detail-map="materialIdToDetailMap"
              @showWfInstanceDetails="showWfInstanceDetails"
              :active-material="activeMaterial"
              @selectActiveMaterial="(material) => (activeMaterial = material)"
            />
          </div>
          <div
            v-else-if="
              wftInstaceId && selectedTab === config.FORM_TAB_STATUS.WORKFLOW
            "
          >
            <div class="activeStep">
              <!-- Top Row -->
              <div class="step-header space-between v-center">
                <div class="v-center">
                  <img
                    src="~@/assets/images/icons/arrow-back.svg"
                    width="25"
                    @click="goBackFromWorkflowDetails"
                    class="pointer mr-2"
                    v-if="
                      formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF
                    "
                  />
                  <div v-overflow-tooltip class="step-name elipsis-text">
                    {{ workflowData?.stepName }}
                  </div>
                  <div class="mb-1 ml-2">
                    <div
                      :class="{
                        'v-center workflowStatus status-tag': true,
                        'not-started':
                          workflowData?.state_value?.name === 'NOT_STARTED',
                        ongoing: workflowData?.state_value?.name === 'ONGOING',
                        completed:
                          workflowData?.state_value?.name === 'COMPLETED',
                        cancelled:
                          formData.status === config.FORM_STATE_MAP.CANCELLED,
                      }"
                    >
                      <span
                        v-if="
                          formData.status === config.FORM_STATE_MAP.CANCELLED
                        "
                      >
                        CANCELLED</span
                      >
                      <span v-else>{{
                        workflowData?.state_value?.name | statusfomat
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="v-center">
                  <button
                    @click.stop="qcHistory"
                    v-if="workflowData?.qc_parent_step_id"
                    class="fill-qc-btn mr-1"
                  >
                    View QC
                  </button>
                  <router-link
                    :to="`/workflows/${workflowData?.workflowTypeName}/?version=${workflowData?.workflow_version_id}&wfinstance=${wftInstaceId}`"
                    target="_blank"
                  >
                    <button
                      class="btn btn-2 v-center"
                      v-tooltip="'View Workflow'"
                    >
                      <img
                        src="~@/assets/images/icons/workflows.svg"
                        width="18px"
                        height="18px"
                        alt="View Workflow"
                      />
                    </button>
                  </router-link>
                </div>
              </div>
              <div v-if="formData.status === config.FORM_STATE_MAP.CANCELLED">
                <span class="xs label">Reason for cancellation:</span>
                <div>{{ workflowData?.comment ?? "--" }}</div>
              </div>
              <div
                class="v-center"
                v-if="
                  formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF &&
                  this.selectedMaterial.number
                "
              >
                <div class="v-center">
                  <div class="dept">Material :</div>
                  <div class="date-value ml-1">
                    {{
                      `${this.selectedMaterial?.name} #${this.selectedMaterial.number}`
                    }}
                  </div>
                </div>
                <div
                  v-if="workflowData?.workflow_stage?.qc_parent_step_id"
                  class="v-center"
                >
                  <label class="dept">Checklist Status:</label>
                  <div :class="['status-display']">
                    <div class="status-icon">
                      <div
                        :class="[
                          'status-circle',
                          getStatusClass({ value: workflowData?.qcFormStatus }),
                        ]"
                      >
                        <span class="status-symbol">{{
                          getStatusIcon({ value: workflowData?.qcFormStatus })
                        }}</span>
                      </div>
                    </div>
                    <span class="status-text">{{
                      workflowData?.qcFormStatus | getQCStatusName
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="flex v-venter">
                <div class="dept">Workflow Template :</div>
                <div class="date-value ml-1">
                  {{ workflowTemplateName }}
                </div>
              </div>
              <!-- Dept Row -->
              <div
                class="flex v-venter"
                v-if="workflowData?.state_value?.name !== 'COMPLETED'"
              >
                <div class="dept">Department :</div>
                <div class="date-value ml-1">
                  {{ workflowData?.core_user_group?.name ?? "--" }}
                </div>
                <br />
              </div>
              <div
                class="v-center"
                v-if="
                  workflowData?.state_value?.name !== 'COMPLETED' &&
                  formattedIndependentUsers.length
                "
              >
                <div class="dept">Assignees :</div>
                <div class="avatar-container flex ml-3">
                  <avatar
                    v-for="user in formattedIndependentUsers"
                    :key="user.id"
                    :user="user.assigned_user"
                    :title="getUserTooltip(user.assigned_user)"
                    style="margin-right: -9.5px"
                  />
                  <avatar
                    style="margin-right: -13.5px"
                    v-if="formattedIndependentUsersExceededCount"
                    :exceeded-count="formattedIndependentUsersExceededCount"
                    :title="
                      formattedIndependentUsersExceededCount + ' ' + 'more'
                    "
                  />
                </div>
                <br />
              </div>
              <div class="border"></div>
              <!-- Date/Duration Row -->
              <div class="date-row space-between">
                <div class="date-block">
                  <div class="xs label">Start Date</div>
                  <div class="flex v-center">
                    <div class="date-detail mr-1">Expected :</div>
                    <div class="date-value">
                      {{ workflowData.planned_start_date | genericFormatDate }}
                    </div>
                  </div>
                  <div class="flex v-center">
                    <div class="date-detail">Actual :</div>
                    <div class="date-value">
                      {{ workflowData.actual_start_date | genericFormatDate }}
                    </div>
                  </div>
                </div>
                <div
                  class="duration-block"
                  v-if="workflowData?.state_value?.name !== 'COMPLETED'"
                >
                  <div class="label">Duration</div>
                  <div class="duration-value">{{ formattedDuration }}</div>
                </div>

                <div class="date-block">
                  <div class="xs label">End Date</div>
                  <div class="v-center">
                    <div class="date-detail">Expected :</div>
                    <div class="date-value">
                      {{ workflowData?.planned_end_date | genericFormatDate }}
                    </div>
                  </div>
                  <div class="flex v-center">
                    <div class="date-detail">Actual :</div>
                    <div class="date-value">
                      {{
                        workflowData?.actual_end_date
                          | genericFormatDate
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- Upload Section -->
              <!-- <div class="upload-row">
          <div class="upload-box">
          <div class="weight-500" >File Upload</div>
        <img src="~@/assets/images/icons/upload-icon.svg" class="upload-icon" />
        <button class="btn">Browse</button>
      </div>
  <div class="uploaded-files-box">
    <div class="uploaded-header">Uploaded files</div>
    <div v-if="files.length" class="uploaded-list">
      <div
        v-for="(file, index) in files"
        :key="index"
        class="uploaded-file"
      >
        <div class="file-name">{{ file.name }}</div>
        <div class="file-status">
          <span v-if="file.status === 'uploading'" class="loader"></span>
          <span v-else>{{ file.size }}</span>
        </div>
      </div>
    </div>
      <div v-else class="no-files">
    No Files Attatched
  </div>
  </div>
        </div> -->
        <div
        class="resource-item"
        v-if="workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0 && selectedResources.length > 0"
        >
                <div class="border"></div>
                <div class="resource-select-container">

                  <!-- same data used for mapping and show selected resources -->
                 <resource-selection-comp
                    :availableResources="selectedResources"
                    :selectedResources="selectedResources"
                    :readOnly="true" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedTab === config.FORM_TAB_STATUS.LINKED_ENTITIES">
            <linked-entities
              :entities="entities"
              :form-id="this.$route.params.formId"
              @refresh-links="fetchLinkedEntities"
            />
          </div>
        </div>
      </div>
    </div>
    <qc-inspection-dialog
      v-if="showQCDialog"
      :qcTemplateId="qcData.qcTemplateId"
      :qcformId="qcData.qcformId"
      :stepName="qcData.stepName || '--'"
      :edit="qcData.edit"
      @close="closeQCDialog"
      @showQCHistory="handleQCHistory"
    />
    <qc-iteration-list-dialog
      v-if="showQCHistoryDialog"
      :iterations="stepHistory"
      :stepHistory="stepHistory"
      :stepId="qcData.step_id"
      :instanceId="qcData.instance_id"
      :showFillInspection="false"
      @close="closeQCHistoryDialog"
      @viewInspection="viewInspection"
    />
  </div>
</template>

<script>
import {
  // EditForm,
  getDetailFormTemplate,
  GetFormDataByFormId,
  getGivenCustomListsData,
  workflowDataBasedOnInstanceId,
  getFormLinks,
  manualLinkedFormQuery,
  GetJobOrderMaterialLinksInst,
  getWfStepHistory,
  getLastStepHistoryData
} from '@/api'
import { mapGetters } from 'vuex'
import { alert } from '@/plugins/notification'
import { genericFormatDate } from '@/utils/date'
import { timeStampToDate } from '@/filters/dateFilter'
import { GetFormValueMap } from '@/helper/formValue.js'
import config from '@/config'
import UploadDocument from '@/components/document/uploadDocument.vue'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import LoadingCircle from '../../components/common/loadingCircle.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import contactListComponent from '@/components/form/elements/contactListComponent.vue'
import documentsComponent from '@/components/form/elements/documentsComponent.vue'
import FormCommentPanel from '../../components/form/formCommentPanel.vue'
import bomComponent from '@/components/form/elements/bomComponent.vue'
import TagsComponent from '@/components/form/elements/tagsComponent.vue'
import processPlanList from './processPlanList.vue'
// import confirmationDialog from '@/plugins/confirmationDialog'
import versionHistory from './versionHistory.vue'
import LinkedEntities from './linkedEntities.vue'
import Avatar from '@/components/common/avatar.vue'
import Loader from '@/plugins/loader'
import QcIterationListDialog from '@/components/materialMaster/qcIterationListDialog.vue'
import QcInspectionDialog from '@/components/materialMaster/qcInspectionDialog.vue'
import tableTemplate from '../SETTINGS/tableTemplate.vue'
import resourceSelectionComp from '@/components/form/resourceSelectionComp.vue'
// import { alert, success } from '@/plugins/notification'
const componentAlignment = {
  BOOLEAN: 1,
  NUMBER: 1,
  TEXT: 1,
  LONG_TEXT: 2,
  DATE: 1,
  TIME: 1,
  CONFIGURATION_LIST: 1,
  ATTACHMENT: 2,
  COMPANY: 1,
  USER: 1,
  MULTI_USER: 2,
  MATERIALS: 2,
  LOCATION: 2,
  PRODUCT_CODE: 1,
  BOM: 2,
  TAGS: 2,
  CONTACT_LIST: 2,
  DOCUMENTS: 2,
  TABLE: 2
}

export default {
  name: 'ViewFormComponent',
  components: {
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    BOM_COMPONENT: bomComponent,
    TAGS_COMPONENT: TagsComponent,
    CONTACT_LIST_COMPONENT: contactListComponent,
    DOCUMENTS_COMPONENT: documentsComponent,
    TABLE_COMPONENT: tableTemplate,
    processPlanList,
    LoadingCircle,
    FormCommentPanel,
    versionHistory,
    UploadDocument,
    LinkedEntities,
    Avatar,
    QcIterationListDialog,
    QcInspectionDialog,
    resourceSelectionComp
  },
  filters: {
    timeStampToDate,
    genericFormatDate,
    statusfomat (value) {
      if (!value) return ''
      return value.replace(/_/g, ' ')
    },
    getQCStatusName (value) {
      if (!value) return ''
      else if (value === config.FORM_STATE_MAP.APPROVED) return 'Approved'
      else if (value === config.FORM_STATE_MAP.REJECTED) return 'Rejected'
      else if (value === config.FORM_STATE_MAP.HOLD) return 'Hold'
      else if (value === config.FORM_STATE_MAP.IN_PROGRESS) return 'In Progress'
    }
  },
  data () {
    return {
      sideBarLoading: false,
      selectedMaterial: {
        number: null,
        name: ''
      },
      activeMaterial: '',
      materialNames: [],
      materialLinks: [],
      materialIdToDetailMap: {},
      formattedIndependentUsers: [],
      formattedIndependentUsersExceededCount: 0,
      entities: [],
      files: [],
      templateId: '',
      templateName: '',
      formTemplateData: {},
      formData: {},
      formValueData: {},
      loading: false,
      openComment: false,
      wftInstaceId: null,
      workFlowId: null,
      workflowData: {},
      selectedTab: 1,
      loadViewForm: false,
      tabs: [
        {
          id: 1,
          name: 'WorkFlow'
        },
        {
          id: 2,
          name: 'Comments'
        },
        {
          id: 3,
          name: 'Version History'
        },
        {
          id: 4,
          name: 'History'
        },
        {
          id: 5,
          name: 'Linked Entities'
        }
      ],
      config: config,
      selectedResources: [],
      showQCHistoryDialog: false,
      showQCDialog: false,
      stepHistory: [],
      qcData: {}
    }
  },
  computed: {
    ...mapGetters(['isOnProjectLevel', 'user', 'collaborator', 'openProjectId', 'isExternalCollaborator', 'openTenantId']),
    workflowTemplateName () {
      return this.workflowData?.workflowTemplateName || this.templateName || '--'
    },
    visibleTabs () {
      return this.tabs.filter(tab => {
        const isJOF = this.formData.form_type_id === this.config.FORM_TEMPLATE_TYPE.JOF
        if (this.formData.form_type_id === 5 && tab?.name === 'Version History') return false
        if (!this.wftInstaceId && ['WorkFlow', 'Linked Entities'].includes(tab.name) && !isJOF) return false
        return true
      })
    },
    formattedDuration () {
      const duration = this.workflowData?.duration
      const durationType = this.workflowData?.duration_type

      if (!duration || !durationType) return '--'

      return this.formatDuration(duration, durationType)
    },
    formattedDueDate () {
      return timeStampToDate(this.formData.due_date)
    },
    formVersion () {
      return this.formTemplateData?.template_versions?.find(
        (item) => item.id === this.formData.template_version_id
      )
    },
    templateField () {
      return this.formVersion?.template_fields
    },

    editPermission () {
      if (this.formData.status === config.FORM_STATE_MAP.CLOSED || this.formData.status === config.FORM_STATE_MAP.CANCELLED) {
        return false
      }
      if (
        this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN' || this.user.userId === this.formData.created_by_user?.id) {
        return true
      }
      if (this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF) {
        // const enableEditBtn=false
        if (this.formdata?.created_by === this.user.userId && (this.user.tenantLevelRole === 'COLLABORATOR' || this.user.projectLevelRole !== 'COLLABORATOR')) { return true }

        for (const material of this.materialLinks) {
          if (this.isAssignee(material?.workflow_instance?.current_instance_step?.workflow_step?.core_user_group?.core_user_group_members)) { return true }
          if (this.isAssignee(material?.workflow_instance?.current_instance_step?.instance_step_assignees)) { return true }
        }
      }

      if (this.formData.forms_user_lists.length) {
        const isAssigned = this.formData.forms_user_lists.some(
          assignee => (assignee.user_id === this.user.userId && this.openTenantId === assignee.target_tenant_id)
        )
        if (isAssigned) return true
      }
      if (this.wftInstaceId && this.workflowData?.core_user_group) {
        for (const user of this.workflowData?.core_user_group.core_user_group_members) {
          if (this.user.userId === user.user_id) {
            return true
          }
        }
        if (this.workflowData?.instance_step_assignees) {
          const isAssignee = this.isAssignee(this.workflowData?.instance_step_assignees)
          if (isAssignee) {
            return isAssignee
          }
        }
      }
      if (!this.workflowData?.core_user_group) {
        const isAssignee = (this.user.userId === this.formData.created_by_user?.id || this.isAssignee(this.workflowData?.instance_step_assignees))
        if (isAssignee) {
          return isAssignee
        }
      }

      return false
    },
    showReOpen () {
      if (this.formData.status === 4 && this.formData.form_type_id !== 5 && (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') && !this.collaborator && this.formData.next_revisions_aggregate.aggregate.count === 0 && this.formData.form_type_id !== config.DOCUMENT_REVISIONING_FORM.form_type) {
        return true
      } else {
        return false
      }
    },
    mappedResourceOptions () {
      return this.selectedResources.map(resource => ({
        id: resource.value,
        name: resource.label,
        disabled: false
      }))
    },
    selectedResourceIds () {
      return this.selectedResources.map(r => r.value)
    }
  },
  methods: {
    getComponentGridClass (key) {
      const span = componentAlignment[key] || 1
      return span === 2 ? 'form-grid__item--span-2' : 'form-grid__item--span-1'
    },
    formatDuration (duration, durationType) {
      // If Days, just show as is
      if (durationType === 1) {
        return `${duration} ${duration === 1 ? 'Day' : 'Days'}`
      }

      // If Hours
      if (durationType === 2) {
        const days = Math.floor(duration / 24)
        const hours = duration % 24

        if (days > 0 && hours > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'} ${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        } else if (days > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'}`
        } else {
          return `${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        }
      }

      // If Minutes
      if (durationType === 3) {
        const days = Math.floor(duration / (60 * 24))
        const hours = Math.floor((duration % (60 * 24)) / 60)
        const minutes = duration % 60

        const parts = []
        if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`)
        if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`)
        if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'Min' : 'Mins'}`)

        return parts.length > 0 ? parts.join(' ') : '0 Mins'
      }

      return `${duration} ${this.config.DURATION_TYPE[durationType]}`
    },
    setDefaultTab () {
      this.selectedTab = this.visibleTabs[0]?.id || null
    },
    goBackFromWorkflowDetails () {
      this.wftInstaceId = null
      this.workflowData = {}
      this.workFlowVersionId = null
      // Remove mInstDetails from URL when going back to list
      const newQuery = { ...this.$route.query }
      delete newQuery.mInstDetails
      this.$router.push({
        path: this.$route.path,
        query: newQuery
      })
    },
    showWfInstanceDetails (obj) {
      this.sideBarLoading = true
      this.wftInstaceId = obj.instanceId
      this.selectedMaterial.number = obj.index + 1
      this.selectedMaterial.name = obj.name
      this.selectedMaterial.materialId = obj.material_id
      this.getWorkFlowStepData()
    },
    findMaterialNameForInstance (instanceId) {
      // Find the material name and index for the given workflow instance ID
      const materialMap = {}
      this.materialLinks.forEach(item => {
        const materialName = item.workflow_instance.core_material_master.material_name
        if (!materialMap[materialName]) {
          materialMap[materialName] = []
        }
        materialMap[materialName].push(item.workflow_instance)
      })

      // Search for the instance ID in the material map
      for (const [materialName, instances] of Object.entries(materialMap)) {
        const instanceIndex = instances.findIndex(inst => inst.id === instanceId)
        if (instanceIndex !== -1) {
          this.selectedMaterial.name = materialName
          this.selectedMaterial.number = instanceIndex + 1
          break
        }
      }
    },
    getUserTooltip (user) {
      return `${user.first_name} ${user.last_name}`
    },
    handleFileUpload (event) {
      const selectedFiles = Array.from(event.target.files)
      console.log(selectedFiles)
      selectedFiles.forEach(file => {
        this.files.push({
          name: file.name,
          status: 'uploading',
          rawFile: file
        })
        // Simulate upload
        setTimeout(() => {
          file.status = 'done'
        }, 1000)
      })
    },
    setup (form) {
      const updatedFormId = form ? form.id : this.$route.params.formId
      this.loading = true
      this.loadViewForm = true
      GetFormDataByFormId(updatedFormId, this.isOnProjectLevel, this.isExternalCollaborator).then(
        (res) => {
          this.formData = res.core_forms_by_pk
          if (this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF) {
            GetJobOrderMaterialLinksInst(updatedFormId).then((ress) => {
              this.materialLinks = ress?.job_order_material_links || []
              for (const item of res.core_forms_by_pk.forms_material_lists) {
                this.materialIdToDetailMap[item.core_material.id] = {
                  id: item.core_material.id,
                  name: item.core_material?.material_name,
                  stepId: item.core_material?.workflow_template?.workflow_versions[0]?.workflow_stages[0]?.id,
                  quantity: item.quantity
                }
              }

              // If mInstDetails is in URL, find and set the material name
              const mInstDetailsId = this.$route.query.mInstDetails
              if (mInstDetailsId && this.wftInstaceId === mInstDetailsId) {
                this.findMaterialNameForInstance(mInstDetailsId)
              }
            }).catch((err) => {
              console.log(err)
              alert('Failed to fetch job order material links')
            })
          }
          this.fetchLinkedEntities(updatedFormId).catch(() => {})
          const { formValueMap } = GetFormValueMap(res.core_forms_by_pk)
          this.formValueData = formValueMap
          // Don't overwrite wftInstaceId if it's already set from mInstDetails URL parameter
          const mInstDetailsId = this.$route.query.mInstDetails
          if (!mInstDetailsId) {
            this.wftInstaceId = res.core_forms_by_pk.workflow_instance_id
          }
          this.getWorkFlowStepData(this.wftInstaceId)
          this.getFormTemplateData()
        }
      ).catch(() => {
        alert('Failed to fetch form data')
        this.loading = false
        this.loadViewForm = false
      })
    },
    async fetchLinkedEntities (formId) {
      const currentFormId = formId || this.$route.params.formId
      const [linksResult, blocksResult, blockedByResult, relatesToResult] = await Promise.allSettled([
        getFormLinks(currentFormId),
        manualLinkedFormQuery(currentFormId, config.LinkTypes.BLOCKS),
        manualLinkedFormQuery(currentFormId, config.LinkTypes.BLOCKED_BY),
        manualLinkedFormQuery(currentFormId, config.LinkTypes.RELATES_TO)
      ])
      const links = linksResult.status === 'fulfilled' ? linksResult.value : null
      const manualBlocks = blocksResult.status === 'fulfilled' ? blocksResult.value : null
      const manualBlockedBy = blockedByResult.status === 'fulfilled' ? blockedByResult.value : null
      const manualRelatedTo = relatesToResult.status === 'fulfilled' ? relatesToResult.value : null
      const systemGeneratedLinks = (links?.message || []).map(item => ({
        ...item,
        link_type_id: config.LinkTypes.RELATES_TO,
        link_source_type: 'SYSTEM',
        is_manual_link: false
      }))

      const manualLinks = [
        ...(manualBlocks?.linking_service || []),
        ...(manualBlockedBy?.linking_service || []),
        ...(manualRelatedTo?.linking_service || [])
      ]
      const manuallyLinkedForms = manualLinks.map(item => {
        const resolvedLinkTypeId = Number(item?.link_type_id) || Number(config.LinkTypes[item?.link_type?.type]) || config.LinkTypes.RELATES_TO
        // Handle either direction by resolving "other" form safely.
        const relatedForm = (item?.target_id === currentFormId || item?.target_form?.id === currentFormId)
          ? item?.source_form
          : item?.target_form
        const updatedByFirstName = relatedForm?.updated_by_user?.first_name || ''
        const updatedByLastName = relatedForm?.updated_by_user?.last_name || ''
        const updatedBy = `${updatedByFirstName} ${updatedByLastName}`.trim()
        return {
          id: item.id,
          form_id: relatedForm?.id || item?.target_id,
          form_template_id: relatedForm?.template_version?.template_id,
          template_name: relatedForm?.template_version?.core_form_template?.name,
          sequence_value: relatedForm?.sequence_value,
          updated_on: relatedForm?.updated_on,
          updated_by: updatedBy || '--',
          status: relatedForm?.status,
          link_type_id: resolvedLinkTypeId,
          metadata: item?.metadata,
          created_by: item?.created_by,
          created_on: item?.created_on,
          tenant_id: item?.tenant_id,
          link_source_type: 'MANUAL',
          is_manual_link: true
        }
      })

      const mergedEntities = [...systemGeneratedLinks, ...manuallyLinkedForms]
      const uniqueEntitiesByFormId = new Map()

      mergedEntities.forEach((item) => {
        const key = `${item.form_id}-${item.link_type_id}`
        const existing = uniqueEntitiesByFormId.get(key)
        // Prefer manual link record when both system and manual entries exist for same form and link type.
        if (!existing || (!existing.is_manual_link && item.is_manual_link)) {
          uniqueEntitiesByFormId.set(key, item)
        }
      })

      this.entities = Array.from(uniqueEntitiesByFormId.values())
    },
    getValuesFromForm (key) {
      key = key.toLowerCase()
      switch (key) {
      case 'project':
        if (this.formData.project_id) {
          return this.formData?.core_project?.name
        } else {
          return '--'
        }
      case 'factory':
        if (this.formData.factory_id) {
          return this.formData?.core_factory?.name
        } else {
          return '--'
        }
      case 'created on':
      case 'created_on':
        if (this.formData.created_on) {
          return timeStampToDate(this.formData.created_on)
        }
        return ''
      case 'created by':
      case 'created_by': {
        if (this.formData.created_by) {
          return (
            this.formData.created_by_user.first_name +
              ' ' +
              this.formData.created_by_user.last_name
          )
        }
        return ''
      }
      case 'updated_on':
      case 'updated on':
        if (this.formData.updated_on) {
          return timeStampToDate(this.formData.updated_on)
        }
        return ''
      case 'updated_by':
      case 'updated by': {
        if (this.formData.updated_by) {
          return (
            this.formData.updated_by_user.first_name +
              ' ' +
              this.formData.updated_by_user.last_name
          )
        }
        return ''
      }
      }
    },
    getkeysFromForm (key) {
      key = key.toLowerCase()
      switch (key) {
      case 'created_on':
      case 'created_by':
      case 'updated_on':
      case 'updated_by':
      case 'project':
        return null
      case 'factory':
        return 'Factory'
      }
    },
    goBack () {
      this.$router.push(
        `/forms/template/${this.templateId}/list`
      )
    },
    getFormTemplateData () {
      this.loading = true
      this.loadViewForm = true
      getDetailFormTemplate(this.templateId).then(async (res) => {
        this.formTemplateData = res.core_form_templates_by_pk
        const customListData = this.findUsedCustomListIds(res.core_form_templates_by_pk.template_versions)
        if (customListData.size > 0) {
          await this.getGivenCustomList([...customListData])
        }
        this.loading = false
        this.loadViewForm = false
      })
    },
    getWorkFlowStepData () {
      if (!this.wftInstaceId) {
        this.sideBarLoading = false
        return
      }
      workflowDataBasedOnInstanceId(this.wftInstaceId, this.isExternalCollaborator).then((res) => {
        this.workflowData.stepId = res.workflow_instances_by_pk?.workflow_stage?.id
        this.workflowData.qcFormId = res.workflow_instances_by_pk?.workflow_stage?.current_step_transition_history?.[0]?.form_id
        this.workflowData.qcFormStatus = res.workflow_instances_by_pk?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status
        this.workflowData.qc_parent_step_id = res.workflow_instances_by_pk?.workflow_stage?.qc_parent_step_id
        this.workflowData.qc_form_template_id = res.workflow_instances_by_pk?.workflow_stage?.qc_form_template_id
        // this.workflowData.instance_step_assignees = res.workflow_instances_by_pk?.workflow_instance_steps?.[0]?.instance_step_assignees
        this.workflowData.core_user_group = res.workflow_instances_by_pk?.workflow_stage?.core_user_group
        this.workflowData.planned_start_date = res.workflow_instances_by_pk?.workflow_instance_steps?.[0]?.planned_start_date
        this.workflowData.actual_start_date = res.workflow_instances_by_pk.workflow_stage?.current_step_transition_history?.[0].start_date
        this.workflowData.actual_end_date = res.workflow_instances_by_pk.workflow_stage?.current_step_transition_history?.[0].end_date
        this.workflowData.planned_end_date = res.workflow_instances_by_pk?.workflow_instance_steps?.[0]?.planned_end_date
        this.workflowData.comment = res.workflow_instances_by_pk.core_comments?.[0]?.comment || ''
        this.workflowData.state_value = res.workflow_instances_by_pk?.state_value
        this.workflowData.duration = res.workflow_instances_by_pk?.workflow_stage?.duration
        this.workflowData.duration_type = res.workflow_instances_by_pk?.workflow_stage?.duration_type
        this.workflowData.resource_group = res.workflow_instances_by_pk?.workflow_stage?.resource_group
        this.workflowData.workflow_version_id = res.workflow_instances_by_pk?.workflow_version.id
        this.workflowData.workflowTypeName = res.workflow_instances_by_pk?.workflow_version?.workflow_template.type_value?.name
        this.workflowData.workflowTemplateName = res.workflow_instances_by_pk?.workflow_version?.workflow_template?.name
        this.workflowData.stepName = res.workflow_instances_by_pk?.workflow_stage?.name
        this.workflowData.instance_step_resource = res.workflow_instances_by_pk?.workflow_instance_steps[0]?.instance_step_resources[0]
        this.workflowData.stepIterationCount = res.workflow_instances_by_pk?.workflow_instance_steps?.length
        this.workflowData.stepAssigneeCount = res.workflow_instances_by_pk?.workflow_instance_steps[0]?.instance_step_resources[0]?.length
        this.workflowData.workflow_instance_steps = res.workflow_instances_by_pk?.workflow_instance_steps || []
        this.workflowData.workflow_stage = res.workflow_instances_by_pk?.workflow_stage || null
        this.workflowData = {
          ...this.workflowData,
          instance_step_assignees: res.workflow_instances_by_pk?.workflow_instance_steps?.[0]?.instance_step_assignees ?? []
        }
        if (this.workflowData.stepIterationCount) {
          if (this.workflowData?.instance_step_assignees.length < 3) {
            this.formattedIndependentUsers = this.workflowData?.instance_step_assignees
          } else {
            this.formattedIndependentUsers = this.workflowData.instance_step_assignees.slice(0, 3)
            this.formattedIndependentUsersExceededCount = this.workflowData.instance_step_assignees.length - 3
          }

          if (this.workflowData.workflow_instance_steps?.[0]?.instance_step_resources?.length > 0) {
            const resources = this.workflowData.workflow_instance_steps[0].instance_step_resources
            this.selectedResources = resources.map(resource => {
              const isLaborResource = !resource?.factory_resource_instance?.resource_id

              return {
                value: resource.resource_id, // factory_resource_association ID
                label: isLaborResource ? resource?.factory_resource_instance?.resource_user_name : resource?.factory_resource_instance?.name,
                resource_id: resource?.resource_id,
                resourceType: isLaborResource ? 'LABOR' : resource?.factory_resource_instance?.core_material_master?.resource_type_value?.name
              }
            })
          }
        }
        if (this.workflowData.state_value?.name === 'COMPLETED') {
          try {
            getLastStepHistoryData(this.wftInstaceId).then((res) => {
              this.workflowData.stepId = res.workflow_instances_by_pk.transition_history[0].step_id
              this.workflowData.qcFormId = res.workflow_instances_by_pk.transition_history[0].form_id
              this.workflowData.qcFormStatus = res.workflow_instances_by_pk.transition_history[0]?.qc_form?.status
              this.workflowData.qc_parent_step_id = res.workflow_instances_by_pk.transition_history[0]?.current_workflow_step?.qc_parent_step_id
              this.workflowData.qc_form_template_id = res.workflow_instances_by_pk.transition_history[0]?.current_workflow_step?.qc_form_template_id
              this.workflowData.actual_start_date = res.workflow_instances_by_pk.transition_history[0].start_date
              this.workflowData.actual_end_date = res.workflow_instances_by_pk.transition_history[0].end_date
              this.workflowData = { ...this.workflowData }
            })
              .catch(err => {
                console.log(err)
              })
          } catch (err) {
            console.log(err)
          }
        }
      }).catch(err => {
        console.error(err)
        alert('Failed to fetch workflow data')
      }).finally(() => {
        this.sideBarLoading = false
      })
    },
    isAssignee (assignees = []) {
      for (const assignee of assignees) {
        if (assignee.user_id === this.user.userId) {
          return true
        }
      }
    },
    reopenForm () {
      const formId = this.formData.id
      this.$router.push(`/forms/template/${this.templateId}/form/${formId}/reopen`)
      // confirmationDialog(
      //   'Are you sure you want to reopen ?',
      //   (res) => {
      //     if (res) {
      //       EditForm({ formId: formId, status: 3 })
      //         .then((res) => {
      //           this.formData.status = 3
      //           success(res?.message ?? 'Successfully reopened form')
      //         })
      //         .catch(() => {
      //           alert('Failed to reopen form')
      //         })
      //     }
      //   }
      // )
    },
    getFormData (form) {
      const updatedFormId = form ? form.id : this.$route.params.formId
      GetFormDataByFormId(updatedFormId, this.isOnProjectLevel, this.isExternalCollaborator).then(
        (res) => {
          this.formData = res.core_forms_by_pk
          const { formValueMap } = GetFormValueMap(res.core_forms_by_pk)
          this.formValueData = formValueMap
          this.wftInstaceId = res.core_forms_by_pk.workflow_instance_id
          this.getWorkFlowStepData(this.wftInstaceId)
          this.getFormTemplateData()
        }
      )
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    async qcHistory (mm, index) {
      this.qcData = {
        qcformId: this.workflowData?.qcFormId,
        qcTemplateId: this.workflowData?.qc_form_template_id,
        stepName: this.workflowData?.stepName,
        instance_id: this.wftInstaceId,
        step_id: this.workflowData.stepId,
        edit: false
      }
      const loader = new Loader()
      loader.show()
      try {
        const stepHistory = await this.getWorkflowHistory()
        this.stepHistory = stepHistory.message.data
        loader.hide()
        // this is condition if the qc has been rejected and we are coming to fill the qc again then need to show the qc history qc history modal
        this.handleQCHistory()
      } catch (error) {
        console.log(error)
        loader.hide()
        alert('Something went wrong')
      }
    },
    handleQCHistory (qcData) {
      this.qcData = {
        qcformId: this.workflowData?.qcFormId,
        qcTemplateId: this.workflowData?.qc_form_template_id,
        stepName: this.workflowData?.stepName,
        instance_id: this.wftInstaceId,
        step_id: this.workflowData.stepId,
        edit: false
      }
      this.showQCDialog = false
      this.showQCHistoryDialog = true
    },
    getWorkflowHistory () {
      return getWfStepHistory(
        this.qcData.instance_id,
        this.qcData.step_id
      )
    },
    closeQCDialog () {
      this.showQCDialog = false
    },
    closeQCHistoryDialog () {
      this.showQCHistoryDialog = false
    },
    viewInspection (qcData) {
      this.qcData = {
        qcformId: qcData.qcformId,
        qcTemplateId: qcData.qcTemplateId,
        stepName: qcData.operation,
        instance_id: this.wfInstaceId,
        step_id: this.workflowData.stepId,
        edit: false
      }
      this.showQCDialog = true
      this.showQCHistoryDialog = false
    },
    getStatusClass (status) {
      const statusClasses = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: 'in-progress',
        [config.FORM_STATE_MAP.APPROVED]: 'approved',
        [config.FORM_STATE_MAP.REJECTED]: 'rejected',
        [config.FORM_STATE_MAP.HOLD]: 'hold'
      }
      return statusClasses[status?.value] || 'in-progress'
    },
    getStatusIcon (status) {
      const statusIcons = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: '✓',
        [config.FORM_STATE_MAP.APPROVED]: '✓',
        [config.FORM_STATE_MAP.REJECTED]: '✗',
        [config.FORM_STATE_MAP.HOLD]: '⏸'
      }
      return statusIcons[status?.value] || '✓'
    },
    redirectToEditForm () {
      const mInstDetailsId = this.$route.query.mInstDetails
      if (mInstDetailsId) {
        this.$router.push(`/forms/template/${this.templateId}/form/${this.formData.id}/edit?mInstDetails=${mInstDetailsId}`)
      } else {
        this.$router.push(`/forms/template/${this.templateId}/form/${this.formData.id}/edit`)
      }
    },
    selectTab (tabId) {
      if (this.$route.query.wfhistory) {
        const { wfhistory, ...rest } = this.$route.query
        this.$router.replace({
          path: this.$route.path,
          query: rest
        })
      }
      this.selectedTab = tabId
    }
  },
  mounted () {
    this.setDefaultTab()
    // If mInstDetails is present in URL, switch to WORKFLOW tab and directly open details
    const mInstDetailsId = this.$route.query.mInstDetails
    if (mInstDetailsId) {
      this.selectedTab = this.config.FORM_TAB_STATUS.WORKFLOW
      // Directly set the workflow instance ID to skip the list view
      this.wftInstaceId = mInstDetailsId
      this.sideBarLoading = true
    }
    this.setup()
  },
  watch: {
    '$route.params.formId' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.templateId = this.$route.params.templateId
        this.setup()
      }
    },
    '$route.query': {
      handler (newQuery) {
        // Switch to WORKFLOW tab when mInstDetails is added to URL
        const mInstDetailsId = newQuery.mInstDetails
        if (mInstDetailsId && this.formData.form_type_id === this.config.FORM_TEMPLATE_TYPE.JOF) {
          this.selectedTab = this.config.FORM_TAB_STATUS.WORKFLOW
        }
      },
      deep: true
    },
    visibleTabs () {
      this.setDefaultTab()
    }
  },
  created () {
    this.templateId = this.$route.params.templateId
    this.templateName = this.$route.params.templateName
    this.setup()
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1600px) {
  .view-form--maincontainer {
    margin-right: auto;
    margin-left: auto;
    // width: 80%;
  }
}
.view-form {
  &--container {
    padding: 3px 20px;
    flex: 1;
    // margin: 0 auto;
    height: 100%;
    overflow-y: auto;
    background-color: var(--white);
  }
  &--sideBar {
    // padding: 20px;
    flex: 1;
    margin-top: 9px;
    height: calc(100%);
    // overflow-y: auto;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    // background: white;
    // & .activeStep {
    //   display: flex;
    //   flex-direction: column;
    //   gap: 20px;
    //   box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    //   padding: 20px;
    //   background: white;
    //   border-radius: 6px;
    //   margin: 1px;
    // }

    & select {
      border: var(--border);
      background-color: transparent;
      border-radius: 4px;
      padding: 4px 8px;
      height: 30px;
      width: 150px;
      outline: none;

      &:focus {
        border-color: var(--brand-color);
      }
    }
  }

  &--maincontainer {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 20px;
    height: calc(100% - 60px);
    background-color: var(--white);
  }

  &--elements {
    height: -webkit-fill-available;
  }

  // .form-grid {
  //   display: grid;
  //   grid-template-columns: repeat(2, minmax(0, 1fr));
  //   gap: 15px 8px;
  //   align-items: start;
  // }

  // .form-grid__item {
  //   display: flex;
  //   flex-direction: column;
  //   gap: 8px;
  //   width: 100%;
  // }

  // .form-grid__item--span-2 {
  //   grid-column: span 2;
  // }

  // .form-grid__item--span-1 {
  //   grid-column: span 1;
  // }

  // @media (max-width: 500px) {
  //   .form-grid {
  //     grid-template-columns: 1fr !important;
  //   }

  //   .form-grid__item,
  //   .form-grid__item--span-1,
  //   .form-grid__item--span-2 {
  //     grid-column: 1 / -1 !important;
  //   }
  // }

  &-step-selection {
    width: 100%;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    padding: 20px;
    background: white;
    border-radius: 6px;

    &-list {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      justify-content: center;
    }

    &-item {
      border: 1px solid rgb(73, 73, 73, 0.3);
      padding: 10px 20px;
      border-radius: 5px;
      background-color: rgb(126, 172, 248, 0.6);
      font-size: var(--text-s);
      color: black;
      cursor: pointer;
    }
  }
}

.view-form .form-grid__item {
  min-width: 0;
}

.view-form .form-grid__item ::v-deep .form-input {
  width: 100%;
}

.view-form .form-grid__item ::v-deep .form-input__label {
  min-height: 18px;
  line-height: 18px;
  margin-bottom: 6px;
}

.view-form .form-grid__item ::v-deep .form-input__caption {
  line-height: 18px;
}

.view-form .form-grid__item ::v-deep .form-input input,
.view-form .form-grid__item ::v-deep .form-input select {
  height: 38px;
  min-height: 38px;
}

.view-form .form-grid__item ::v-deep .form-input textarea {
  min-height: 120px;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;

  & .label {
  }

  & .value {
  }
}

.comment-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 12px;
  z-index: 9;
  background: var(--white);
  cursor: pointer;
  border-radius: 50%;
  height: 45px;
  width: 45px;
  border: none;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);

  & img {
    width: 30px;
    height: 30px;
  }

  &:hover {
    background: var(--brand-color);

    & img {
      filter: invert(1);
    }
  }

  &:active {
    box-shadow: inset 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
  }
}

.dateComponent {
  font-size: var(--text-s);

  & label {
    font-size: 1.3em;
  }
}
.tabs {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  font-family: sans-serif;
}

.tab-headers {
  display: flex;
  font-size:var(--text-xs2);
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
}

.tab-header {
  padding: 12px 18px;
  cursor: pointer;
  flex: 1;
  justify-content: center;
  text-align: center;
  transition: background 0.3s;
}

.tab-header:hover {
  background-color: #e0e0e0;
}

.tab-header.active {
  background-color: #fff;
  font-weight: 500;
  border-bottom: 2px solid var(--brand-color);
}

.form-comment {
  position: fixed;
  bottom: 30px;
  right: -700px;
  top: 130px;
  width: 400px;
  z-index: 9;

  transition: right 0.8s ease-in-out;

  &[arial-data="open"] {
    right: 20px;
  }
}
.status-tag {
  padding: 2px 4px;
  border-radius: 6px;
  font-weight: 600;
  display: inline-block;
  min-width: 100px;
  text-align: center;
}
.not-started {
  background-color: rgba(255, 0, 0, 0.1);
  color: purple;
}

.completed {
  background-color: rgba(0, 128, 0, 0.1);
  color: green;
}

.ongoing {
  background-color: rgba(255, 165, 0, 0.1);
  color: orange;
}

.cancelled {
  background-color: rgba(198, 39, 52, 0.1);
  color: red;
}

.activeStep {
  padding: 5px 5px;
  background: white;
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;

  .step-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .step-left {
      display: flex;
      flex-direction: column;
      gap: 6px;

      .step-name {
        font-size: var(--text-4xl);
        font-weight: 500;
      }
    }

    .step-center {
      text-align: center;

      .step-label {
        font-size: var(--text-base);
        // color: gray;
      }

      .step-duration {
        font-size: var(--text-2xl);
        font-weight: 500;
      }
    }

    .step-right {
      align-self: flex-start;
    }
  }

  .step-department {
    font-size: var(--text-2xl);
    font-weight: 500;
    color: #333;
  }

  .step-info-row {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    .start-block,
    .end-block {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;

      .block-title {
        font-size: var(--text-l);
        font-weight: 600;
        margin-bottom: 6px;
      }

      .block-item {
        display: flex;
        gap: 8px;

        .label {
          font-weight: 500;
          // color: #666;
        }

        .value {
          font-weight: 600;
        }
      }
    }
  }
}
.activeStep {
  padding: 16px 20px 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.step-name {
  max-width: 330px;
  font-size: var(--text-4xl);
  font-weight: 600;
}

.dept {
  font-size: var(--text-s);
  // margin-top: -20px;
  color: #696969;
  font-weight: 400;
}
.border {
  // box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
  border-top: 1px solid #dcdcdc;
}
.date-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.label {
  font-size: var(--text-s);
  color: #696969;
  font-weight: 400;
}

.date-block {
  display: flex;
  flex-direction: column;
  font-size: var(--text-base);
}

.date-detail {
  margin-right: 2px;
  font-size: var(--text-s);
  color: #696969;
  margin-bottom: 2px;
}
.date-value {
  font-size: var(--text-s);
}

.duration-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.duration-value {
  // color: #696969;
  font-size: var(--text-s);
  font-weight: 500;
  // margin-top: -5px;
}

.upload-row {
  display: flex;
  gap: 20px;
  padding-top: 16px;
  align-items: flex-start;
  border-top: 1px solid #ccc;
  margin-top: 12px;
}

.upload-box {
  flex-direction: column;
  border-right: 1px solid #ccc;
  padding-right: 10px;
  width: 30%;
  height: 100%;
  margin-right: 10px;
  text-align: center;
  padding: 20px;
}
.upload-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 8px;
}

.uploaded-files-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.uploaded-header {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  white-space: nowrap;
}

.uploaded-list {
  overflow-y: auto;
  max-height: 120px;
  padding-right: 8px;
}
.no-files {
}

// remvove these lines when latest ui of form is promoted to staging: start of lines
.view-form .form-autogenerated {
  border-radius: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;

  .autogenerated,
  .span-div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .label {
    color: #2d2c2c;
    font-size: var(--text-m);
    font-weight: 500;
    margin-bottom: 4px;
  }

  .value {
    background-color: rgb(173 208 250 / 40%);
    padding: 5px 8px;
    border: 1px solid #e9e9e9;
    border-radius: 6px;
    color: #3046ea;
    font-size: var(text-s);
    min-width: 0;
    border-color: rgba(151, 179, 249, .38);
  }
}
// remvove these lines when latest ui of form is promoted to staging: end of lines

.uploaded-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  font-size: var(--text-base);
  color: #333;
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.file-status {
  white-space: nowrap;
  font-size: var(--text-m);
  color: #888;
}

.loader {
  width: 14px;
  height: 14px;
  border: 2px solid #ccc;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
}
.tab-body-parent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: -webkit-fill-available;
  overflow: auto;
  background-color: inherit;
}
.resource-item {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .resource-select-container {
    flex: 1;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fill-qc-btn {
  background: #f5f5f5;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: var(--text-s);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(158, 158, 158, 0.3);
  box-shadow: 0 1px 2px rgba(102, 126, 234, 0.2);

  &:hover {
    background: #e8e8e8;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(211, 219, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(189, 191, 197, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(189, 191, 197, 0.3);
  }
}

@media (max-width: 500px) {
  .view-form--maincontainer {
    flex-direction: column;
    padding: 12px;
  }

  .view-form .form-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .view-form .form-grid__item,
  .view-form .form-grid__item--span-1,
  .view-form .form-grid__item--span-2 {
    grid-column: 1 / -1 !important;
  }
}
</style>
